import { EligibilityPlanProps } from '../contexts/PaymentContext';
import { BusnessRule } from '../services/api';
import { ResponseAPI } from './responseApi';
import { AxiosError } from 'axios';

type EligibilityProps = {
  eligibilityType: string;
  document: string;
  documentType: string;
  itemId: string;
  birthDate: string;
};

export const verifyEligibility = async ({
  eligibilityType,
  document,
  documentType,
  itemId,
  birthDate
}: EligibilityProps) => {
  const result: ResponseAPI<EligibilityPlanProps[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as EligibilityPlanProps[]
  };
  try {
    const { data } = await BusnessRule.post('coverage-service/eligibility', {
      eligibilityType,
      document,
      documentType,
      itemId,
      birthDate
    });

    result.data = data;

    return result;
  } catch (error: any) {
    result.error = true;
    result.message = (error as AxiosError).response?.data.message || error.message;
    return result;
  }
};
